module.exports = __webpack_public_path__ + "img/nfxts.08197ad8.png";